import 'css-chunk:src/feature/flip-and-tip/FlipAndTipLocationLogo.module.scss';export default {
  "root": "FlipAndTipLocationLogo_root",
  "has_image": "FlipAndTipLocationLogo_has_image",
  "is_customer_facing": "FlipAndTipLocationLogo_is_customer_facing"
};